import React from 'react';
import { InternalApiDataUploadStatus } from '../api-internal';
import { formatEnumLabel } from '../common/helper';
import './DataUploadStatus.scss';

interface DataUploadStatusProps {
  status: InternalApiDataUploadStatus;
}

export const DataUploadStatus = ({ status }: DataUploadStatusProps) => {
  switch (status) {
    case InternalApiDataUploadStatus.PREPARING:
      return <td>{formatEnumLabel(status)}...</td>;
    case InternalApiDataUploadStatus.PROCESSING:
      return <td>{formatEnumLabel(status)}...</td>;
    case InternalApiDataUploadStatus.FAILED:
      return <td className='text-red'>{formatEnumLabel(status)}</td>;
    case InternalApiDataUploadStatus.PARTIALLY_COMPLETED:
      return <td className='text-yellow'>{formatEnumLabel(status)}</td>;
    case InternalApiDataUploadStatus.COMPLETED:
      return <td className='text-green'>{formatEnumLabel(status)}</td>;
    default:
      return <td>{formatEnumLabel(status)}</td>;
  }
};
